import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { UserDetailsResponse } from '../types';
import { PATHS } from '../utils';

const fetchUserInfo = async (
  authorization: string,
  remote_user: string,
): Promise<UserDetailsResponse> => {
  const response = await apiHandler({
    url: PATHS.USER_DETAILS,
    method: METHOD.GET,
    headers: { authorization, remote_user },
  });
  if (!response.ok) throw new Error(response.statusText);

  return (await response.json()) as Promise<UserDetailsResponse>;
};

export default fetchUserInfo;
